import { __ } from '@app/shared/functions/object.functions';

import { Role } from '../classes/Role';

export class RoleHelper {
  static Roles: { displayName: string; value: Role }[] = [
    {
      // The role is still called Administrator in the identity server and the API; users know it as Podcaster.
      displayName: 'Podcaster',
      value: Role.Administrator,
    },
    {
      displayName: 'Company Administrator',
      value: Role.CompanyAdministrator,
    },
    {
      displayName: 'Listener',
      value: Role.User,
    },
  ];

  static GetExtendedRoleByNameOrNull(displayName: string): { displayName: string; value: Role } | null {
    const result = RoleHelper.Roles.find((status) => status.value === displayName);
    if (__.IsNullOrUndefinedOrEmpty(result)) {
      return null;
    }
    return result ?? null;
  }

  static GetExtendedRoleByValueOrNull(value: Role | string): { displayName: string; value: Role } | null {
    const result = RoleHelper.Roles.find((status) => status.value === value);
    if (__.IsNullOrUndefinedOrEmpty(result)) {
      return null;
    }
    return result ?? null;
  }
}
